/* eslint-disable no-param-reassign */
import isEqual from 'lodash/isEqual';
import { AdventuresState, AdventureDraft } from './types';

const createInitialAdventureDraft = (): AdventureDraft => ({
  id: null,
  adventureCategoryId: null,
  adventureCategoryImage: null,
  adventureCategoryName: null,
  adventureParentSupplies: [],
  adventureSitterSupplies: [],
  ageRangeText: null,
  ageRangeIds: [],
  description: null,
  duration: null,
  sitterAvailability: null,
  sitterPassion: null,
  surcharge: -1,
  title: null,
  status: null,
  edited: false,
});

const mutations = {
  resetAdventureStore(state: AdventuresState) {
    state.adventureDraft = createInitialAdventureDraft();
    state.pendingEdits = {};
    state.flashMessage = undefined;
  },

  setAdventureDraft(state: AdventuresState, payload: Partial<AdventureDraft>) {
    const prevState = { ...state.adventureDraft, ...state.pendingEdits };
    const newState = { ...prevState, ...payload };

    if (!isEqual(newState, state.adventureDraft)) {
      newState.edited = payload.edited !== undefined ? payload.edited : true;
    }

    state.adventureDraft = newState;
    state.pendingEdits = {};
  },

  setPendingEdits(state: AdventuresState, payload: Partial<AdventureDraft>) {
    state.pendingEdits = payload;
  },

  setFlashMessage(state: AdventuresState, payload: string | undefined) {
    state.flashMessage = payload;
  },
};

export default mutations;
